var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-breadcrumb',{staticClass:"simbar-breadcrumb"},_vm._l((_vm.breadcrumbs),function(item,i){return _c('b-breadcrumb-item',{key:("breadcrumb-" + i),class:{
            'd-sm-none d-block': !!item.middle,
            'd-none d-sm-block':
                i > 0 && i < _vm.breadcrumbs.length - 1 && !!!item.middle,
            'simbar-breadcrumb-item': true
        },attrs:{"to":item.to,"active":i === _vm.breadcrumbs.length - 1}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }